import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import { transferrableAttachments } from '@mimir/common/dto/attachmentPrimitives';
import { SidecarKind } from '@mimir/common/dto/storageModel';
import type { ItemArtefact, TransferRequestPostRequestDtoV2} from '@mimir/common/dto/transferRequestDtos';
import Axios from 'axios';
import capitalize from 'lodash/capitalize';
import { postTransferRequest } from './api';
import type { ArtifactReference } from '@mimir/primitive/artifactReference';

export const getSidecarSelectionTypes = (includeNull = true) => {
  const sidecarKinds = Object
    .values(SidecarKind)
    .filter(val => typeof val === 'string')
    .map(val => ({ text: val, value: val }));
  if (!includeNull) return sidecarKinds;

  return [{ text: 'Disabled', value: null }, ...sidecarKinds];
};

export const sendItemToStorage = async (
  storageId: string,
  itemId: string,
  artefact: ItemArtefact,
  artifactReference: ArtifactReference,
): Promise<OngoingDownload> => {
  const transferRequest: TransferRequestPostRequestDtoV2 = {
    artefact,
    itemId,
    storageId,
    artifactReference,
    version: 'v2',
    targetFileName: undefined,
    createLinkForTargetFileName: false,
  };
  const cancelTokenSource = Axios.CancelToken.source();
  const posedTransferRequest = await postTransferRequest(transferRequest);
  return {
    ...posedTransferRequest,
    artifactReference,
    cancelTokenSource
  };
};

export const getTransferrableAttachmentSelections = () => transferrableAttachments.map(att => ({ label: capitalize(att), value: att }));
